import { useState } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { EmptyState } from "@/components/shared/empty-state";
import { AlignmentGraph } from "@/features/alignment/alignment-graph";
import { useFullAlignment } from "@/hooks/use-full-alignment";
import { YEAR_OPTIONS, DEFAULT_YEAR } from "@/lib/year-options";

function AlignmentSkeleton() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <Skeleton className="h-9 w-36" />
        <Skeleton className="h-10 w-28" />
      </div>
      <Skeleton className="h-[400px] w-full rounded-lg md:h-[600px]" />
    </div>
  );
}

export function AlignmentPage() {
  const [year, setYear] = useState(DEFAULT_YEAR);

  const { data, isLoading, error } = useFullAlignment(year);
  const roots = data?.data ?? [];

  if (isLoading) return <AlignmentSkeleton />;

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="font-heading text-2xl font-semibold sm:text-3xl">Alignment</h1>
        <Select value={String(year)} onValueChange={(v) => setYear(Number(v))}>
          <SelectTrigger className="w-full sm:w-28">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {YEAR_OPTIONS.map((y) => (
              <SelectItem key={y} value={String(y)}>
                {y}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {error ? (
        <EmptyState
          title="Failed to load alignment tree"
          description={error.message}
        />
      ) : roots.length === 0 ? (
        <EmptyState
          title="No strategic plan loaded"
          description="The College strategic hierarchy hasn't been seeded. Contact an admin."
        />
      ) : (
        <AlignmentGraph roots={roots} year={year} />
      )}
    </div>
  );
}
